let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7mSDr")).then(() => parcelRequire('4hBK8'));